import AddRecordingDB from './Containers/AddRecordingDBContainer'

export default AddRecordingDB
